import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
import { Button } from './Button';
interface HeroProps {
  onBookClick: () => void;
}
export function Hero({
  onBookClick
}: HeroProps) {
  return <section className="relative min-h-[90vh] flex items-center overflow-hidden bg-brand-purple" data-id="element-183">
      {/* Background image — actress off to the right */}
      <div className="absolute inset-0 z-0" data-id="element-184">
        <img src="https://cdn.magicpatterns.com/uploads/g9TYjP3qPhpZPriMiRnPde/Glitz_by_Shazz.png" alt="Shazz, celebrity hair stylist, posing against a purple backdrop" className="w-full h-full object-cover object-right" data-id="element-185" />
        {/* Readability film behind the words — invisible over the empty purple at
            wide widths, but provides contrast where text crosses the image as the
            screen narrows */}
        <div className="absolute inset-0 bg-gradient-to-r from-brand-purple via-brand-purple/70 to-transparent" data-id="element-186" />
      </div>

      {/* Left-justified content */}
      <div className="container relative z-10 mx-auto px-6 md:px-12 pt-20" data-id="element-187">
        <div className="max-w-xl text-left" data-id="element-188">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="flex items-center gap-3 mb-4" data-id="element-189">
            <Sparkles className="text-brand-gold w-5 h-5" data-id="element-190" />
            <span className="text-brand-gold uppercase tracking-[0.2em] text-sm font-semibold" data-id="element-191">
              Celebrity Hair Stylist
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.4
        }} className="text-5xl md:text-7xl lg:text-8xl font-serif text-white leading-[1.1] mb-6" data-id="element-192">
            Unleash Your <br data-id="element-193" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-gold via-[#FFF8DC] to-brand-gold" data-id="element-194">
              Inner Glamour
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.6
        }} className="text-lg md:text-xl text-brand-light/90 mb-10 max-w-lg font-light leading-relaxed" data-id="element-195">
            Experience red-carpet readiness with Shazz. Elevating your natural
            beauty with signature styles, flawless extensions, and unparalleled
            artistry.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.8
        }} className="flex flex-col sm:flex-row gap-4" data-id="element-196">
            <Button onClick={onBookClick} size="lg" className="w-full sm:w-auto" data-id="element-197">
              Call to Book
            </Button>
            <Button variant="outline" size="lg" className="w-full sm:w-auto text-white border-white hover:bg-white hover:text-brand-dark" data-id="element-198">
              View Services
            </Button>
          </motion.div>
        </div>
      </div>

      {/* Decorative scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce hidden lg:block" data-id="element-199">
        <div className="w-[1px] h-16 bg-gradient-to-b from-brand-gold to-transparent" data-id="element-200" />
      </div>
    </section>;
}